import * as React from "react";
import { DateFormats, IAvailabilitySchedule } from "intake_shared/src/types";
import moment from "../../../../../utils/app_moment";
import TrashIcon from "../../../icons/Trash";
import { Button } from "../../../bits/Button/Button";
import Table from "../../../bits/Table/Table";
import EmptyListState from "../../../bits/EmptyListState/EmptyListState";
import styles from "../HistoryWrapper.module.scss";

interface TimeOffProps {
    timeOff: IAvailabilitySchedule[];
    onRemoveSchedule: (schedule: IAvailabilitySchedule) => void;
}

export default function TimeOff({ timeOff, onRemoveSchedule }: TimeOffProps) {
    const columns = React.useMemo(() => {
        return [
            {
                Header: "Start date",
                id: "vac-start-time",
                accessor: (row: IAvailabilitySchedule) => {
                    return row?.start
                        ? `${moment(row.start).format(DateFormats.DATE_FORMAT)}`
                        : "--";
                },
            },
            {
                Header: "End date",
                id: "vac-end-date",
                accessor: (row: IAvailabilitySchedule) => {
                    return row?.end
                        ? `${moment(row.end).format(DateFormats.DATE_FORMAT)}`
                        : "--";
                },
            },
            {
                Header: "Updated date",
                id: "vac-udpated-date",
                accessor: (row: IAvailabilitySchedule) => {
                    return row?.updated_at
                        ? `${moment(row.updated_at).format(DateFormats.DATE_FORMAT)}`
                        : "--";
                },
            },
            {
                Header: "Length",
                id: "vac-length",
                accessor: (row: IAvailabilitySchedule) => {
                    return row?.start && row?.end
                        ? `${
                              moment(row.end).diff(moment(row.start), "days") + 1
                          } days`
                        : "--";
                },
            },
            {
                Header: "",
                id: "delete-vac-period",
                accessor: (row: IAvailabilitySchedule) => (
                    <Button
                        variant="normal"
                        onClick={() => {
                            onRemoveSchedule(row);
                        }}
                        className={styles.deleteButton}
                    >
                        <TrashIcon />
                    </Button>
                ),
            },
        ];
    }, [onRemoveSchedule]);
    return timeOff && timeOff?.length > 0 ? (
        <Table columns={columns} data={timeOff} allowSelect={false} />
    ) : (
        <EmptyListState
            emptyMessage="No time off records found"
            stateHelperText="Time off records will appear here"
        />
    );
}
